import { useExportJobsMutation } from 'services/jobsV2';
import { useCallback } from 'react';
import toast from 'react-hot-toast';
import { trackEvent } from 'helpers/analytics';
import { useSelector } from 'react-redux';
import { activeNetworkSelector } from 'redux/selectors';
import { useJobsFilters } from './useJobs/useJobsFilters';

export const useExportJobs = ({ totalJobsInExport, origin, selectedJobs, selectAllJobs, company = null }) => {
  const [exportJobs, { isLoading: isExportingJobs }] = useExportJobsMutation();
  const activeNetwork = useSelector(activeNetworkSelector);
  // companyId is implicit in the path on a company jobs tab, so scope the export via `company` (GSUP-173)
  const { jobsFilters } = useJobsFilters({ forCompany: company });
  const onExportClick = useCallback(() => {
    const isCompanyProfile = window.location.pathname.includes('company-profile');
    exportJobs({
      filters: jobsFilters,
      selectedJobs: selectAllJobs ? undefined : selectedJobs,
      filterByCollection: !isCompanyProfile ? null : false,
    }).then((res) => {
      if (!res.error) {
        trackEvent('jobs:export_csv', {
          collectionId: activeNetwork.id,
          total_jobs_in_export: totalJobsInExport,
          origin,
        });
        toast(`Export in progress — we’ll email it to you in a few minutes.`, {
          icon: 'success',
          id: 'export-jobs',
        });
      } else {
        toast('There was an unexpected error, try again or send us a chat.', {
          icon: 'danger',
          id: 'export-jobs-error',
        });
      }
    });
  }, [activeNetwork.id, exportJobs, jobsFilters, totalJobsInExport, origin, selectedJobs, selectAllJobs]);

  return {
    isExportingJobs,
    onExportClick,
  };
};
